module.exports = __webpack_public_path__ + "img/empty-dark.df299fd7.png";